const Constantes = {
	RUTA_API: "https://dev.marfyl.com/at-backend/src/controllers",
	/* RUTA_API: "https://marfyl.com/at-backend/src/controllers", */
	FB_APP_VAPID_KEY: "BCnwcdf6f3UXLJ6Q2yKC-1Or9ykhQFRKs87TnHPs-dMjy_EKlraUQt03MOs3JsJik6EbrF0ucR3mf-OcNGva8rE",
	FB_API_KEY: "AIzaSyB4c5r1SQgpxWoZAHFumWFniLGbibO9L-U",
};

export default Constantes;